<div class="container">
  <div class="admin-page-header">
    <h1 class="admin-page-title">{{'users'|traduccion}}</h1>
    <button mat-raised-button color="primary" (click)="openNewUser()"><mat-icon>add</mat-icon></button>
  </div>

  <mat-card>
    <app-filter [filters]="fieldFilters" btLabel="Buscar" (submit)="searchUsers(true)"></app-filter>
  </mat-card>

  <div class="table-container">
    <app-data-table
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [emptyMessage]="'No hay usuarios disponibles.'"
      [showPaginator]="true"
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[10, 25, 50]"
      [showFirstLastButtons]="true"
      [rowClickable]="true"
      (rowClick)="openDetails($event.row)"
      (page)="onPageChange($event)">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{'user.name'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef>{{'user.username'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.username }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{'user.email'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef>{{'user.roles'|traduccion}}</th>
        <td mat-cell *matCellDef="let element"><div *ngFor="let role of element.roles">{{ role }}</div></td>
      </ng-container>
    </app-data-table>
  </div>
</div>
